<template>
  <div class="schedule-block">
    <alert-window ref="alertWindow"></alert-window>
    <div class="fieldset date-fieldset">
      <label class="fieldset-title">Дата и время начала</label>
      <fieldset class="date">
        <date-picker
                format="DD.MM.YYYY"
                ref="datePickerFrom"
                lang="ru"
                v-mask="'##.##.####'"
                placeholder="__.__.____"
                :clearable="false"
                :first-day-of-week="1"
                v-model="dateFrom"
        ></date-picker>
      </fieldset>
      <fieldset>
        <input type="text" placeholder="hh:mm" v-mask="'##:##'" v-model="timeFrom" @blur="makeTimeCorrect" id="timeFrom">
      </fieldset>
    </div>
    <div class="fieldset date-fieldset">
      <label class="fieldset-title">Дата и время окончания</label>
      <fieldset class="date">
        <date-picker
                format="DD.MM.YYYY"
                ref="datePickerTo"
                lang="ru"
                v-mask="'##.##.####'"
                placeholder="__.__.____"
                :clearable="false"
                :first-day-of-week="1"
                v-model="dateTo"
        ></date-picker>
      </fieldset>
      <fieldset>
        <input type="text" placeholder="hh:mm" v-mask="'##:##'" v-model="timeTo" @blur="makeTimeCorrect" id="timeTo">
      </fieldset>
    </div>
    <div class="fieldset">
      <label class="fieldset-title">Статус занятости</label>
      <fieldset>
        <select v-model="selectedStatus">
          <option value="work">Рабочая смена</option>
          <option value="weekend">Выходной</option>
          <option value="holiday">Освобожден</option>
          <option value="hill">Болен</option>
        </select>
      </fieldset>
    </div>
    <div class="visibility" v-show="!isNew">
      <span class="string-delete" @click="remove"><i class="fa fa-trash-o"></i>Удалить период</span>
    </div>
  </div>
</template>

<script>
    import AlertWindow from '@/components/AlertWindow.vue'
    import DatePicker from 'vue2-datepicker'
    import {mask} from 'vue-the-mask'
    import VueTimepicker from 'vue2-timepicker'
    import moment from 'moment'
    import {extendMoment} from 'moment-range'
    import api from '@/api'
    import utils from '@/utils'

    export default {
  name: 'SchedulePeriodForDay',
  props: ['arrayIndex', 'day', 'propPeriod', 'periodIsVisible', 'prepareToSave', 'workerId'],
  components: { AlertWindow, DatePicker, VueTimepicker },
  directives: { mask },

  data () {
    return {
      dateFrom: new Date(Date.parse(this.day)).setHours(0, 0, 0, 0),
      dateTo: new Date(Date.parse(this.day)).setHours(0, 0, 0, 0),
      timeFrom: this.propPeriod.wsc_start_work_time,
      timeTo: this.propPeriod.wsc_end_work_time,
      newPeriod: Object.assign({}, this.propPeriod),
      selectedStatus: this.getType(),
      isNew: true
    }
  },
  watch: {
    prepareToSave (val) {
      if (val) {
        let totalPeriodsList = []
        let valid = false
        let isNightShift = false
        let multiplePeriod = false
        if (this.momentFrom.isValid() && this.momentTo.isValid() && this.dateFrom && this.dateTo) {
          let daysBetween = moment(this.dateTo).diff(moment(this.dateFrom), 'days')
          if (daysBetween === 0) {
            if (this.momentFrom.isSameOrAfter(this.momentTo)) {
              this.$refs.alertWindow.show('Ошибка', 'Некорректные данные', false)
            } else {
              valid = true
            }
          } else if (daysBetween > 0) {
            // на несколько дней подряд
            if ((this.selectedStatus ? this.selectedStatus : this.status) === 'work' &&
                this.momentTo.isSameOrBefore(this.momentFrom)) {
              isNightShift = true
            }
            valid = true
            multiplePeriod = true
          } else if (daysBetween < 0) {
            this.$refs.alertWindow.show('Ошибка', 'Дата начала не может быть больше даты окончания', false)
          }
        }
        if (valid) {
          if (this.momentTo.isSame(moment('24:00', 'HH:mm'))) {
            this.timeTo = '23:59'
          }
          this.newPeriod.wsc_date = this.dateFrom
          this.newPeriod.wsc_start_work_time = this.momentFrom.format('HH:mm')
          this.newPeriod.wsc_end_work_time = this.momentTo.format('HH:mm')

          if (isNightShift && !multiplePeriod) {
            let nextDayPeriod = Object.assign({}, this.newPeriod)
            nextDayPeriod.wsc_start_work_time = '00:00'
            nextDayPeriod.wsc_end_work_time = this.momentTo.format('HH:mm')
            nextDayPeriod.wsc_date = moment(this.dateFrom).add(1, 'day').valueOf()
            let currentDayPeriod = Object.assign({}, this.newPeriod)
            currentDayPeriod.wsc_end_work_time = '23:59'
            totalPeriodsList.push(nextDayPeriod)
            totalPeriodsList.push(currentDayPeriod)
          }

          if (multiplePeriod) {
            const Moment = extendMoment(moment)
            let worker
            api.getWorker(this.workerId).then(w => worker = Object.assign({}, w)).then(() => {
              let dismissDate = worker.first.dismiss ? worker.first.dismissDate : null
              let endDay = moment(this.dateTo)
              if (dismissDate) {
                endDay = moment(dismissDate).isBefore(endDay, 'day') ? moment(dismissDate) : moment(this.dateTo)
              }
              if (isNightShift) {
                Array.from(Moment.range(moment(this.dateFrom), (endDay.subtract(1, 'day'))).by('day')).forEach(day => {
                  let period = Object.assign({}, this.newPeriod)
                  period.wsc_id = 0
                  period.wsc_date = day.valueOf()
                  let nextDayPeriod = Object.assign({}, this.newPeriod)
                  nextDayPeriod.wsc_id = 0
                  nextDayPeriod.wsc_start_work_time = '00:00'
                  nextDayPeriod.wsc_end_work_time = this.momentTo.format('HH:mm')
                  nextDayPeriod.wsc_date = moment(day).add(1, 'day').valueOf()
                  period.wsc_end_work_time = '23:59'
                  totalPeriodsList.push(period)
                  totalPeriodsList.push(nextDayPeriod)
                })
                this.$store.commit('updateNewDailyScheduleListForWorker', totalPeriodsList)
                this.$emit('newPeriod')
              } else {
                api.deleteWorkerSchedule(this.workerId, moment(this.dateFrom).format('x'), endDay.format('x'), false).then(() => {
                  Array.from(Moment.range(moment(this.dateFrom), endDay).by('day')).forEach(day => {
                    let period = Object.assign({}, this.newPeriod)
                    period.wsc_id = 0
                    period.wsc_date = day.valueOf()
                    totalPeriodsList.push(period)
                  })
                  this.$store.commit('updateNewDailyScheduleListForWorker', totalPeriodsList)
                  this.$emit('newPeriod')
                })
              }
            }).catch((e) => console.log(e))
          } else if (!isNightShift && !multiplePeriod) {
            totalPeriodsList.push(this.newPeriod)
            this.$store.commit('updateNewDailyScheduleListForWorker', totalPeriodsList)
            this.$emit('newPeriod')
          }
        } else {
          this.$emit('valid', false)
        }
      }
    },
    selectedStatus (val) {
      this.newPeriod.wsc_weekend = false
      this.newPeriod.wsc_holiday = false
      this.newPeriod.wsc_worker_hill = false
      switch (val) {
        case 'weekend':
          this.newPeriod.wsc_weekend = true
          break
        case 'holiday':
          this.newPeriod.wsc_holiday = true
          break
        case 'hill':
          this.newPeriod.wsc_worker_hill = true
          break
      }
    }
  },
  computed: {
    momentFrom () {
      return moment(this.timeFrom, 'HH:mm')
    },
    momentTo () {
      return moment(this.timeTo, 'HH:mm')
    }
  },
  methods: {
    getType () {
      if (this.propPeriod.wsc_weekend) {
        return 'weekend'
      } else if (this.propPeriod.wsc_holiday) {
        return 'holiday'
      } else if (this.propPeriod.wsc_worker_hill) {
        return 'hill'
      } else {
        return 'work'
      }
    },
    remove () {
      if (this.timeFrom === null || this.timeTo === null || this.timeFrom === '' || this.timeTo === '') {
        this.$refs.alertWindow.show('Уведомление', 'Некорректные данные', false)
        return false
      }
      let tempDateTimeFrom = this.timeFrom.split(':')
      if (tempDateTimeFrom[1] !== undefined && tempDateTimeFrom[1] !== '') { tempDateTimeFrom = moment(this.dateFrom).startOf('day').add(tempDateTimeFrom[0], 'hours').add(tempDateTimeFrom[1], 'minutes').format('x') } else { tempDateTimeFrom = moment(this.dateFrom).startOf('day').add(tempDateTimeFrom[0], 'hours').format('x') }
      let tempDateTimeTo = this.timeTo.split(':')
      if (tempDateTimeTo[1] !== undefined && tempDateTimeTo[1] !== '') { tempDateTimeTo = moment(this.dateTo).startOf('day').add(tempDateTimeTo[0], 'hours').add(tempDateTimeTo[1], 'minutes').format('x') } else { tempDateTimeTo = moment(this.dateTo).startOf('day').add(tempDateTimeTo[0], 'hours').format('x') }
      console.log(tempDateTimeFrom)
      console.log(tempDateTimeTo)
      this.$emit('removePeriod',
        {
          id: this.arrayIndex,
          workerId: this.workerId,
          dateFrom: tempDateTimeFrom,
          dateTo: tempDateTimeTo,
          isNew: this.isNew.toSource,
          isWorkPeriod: this.selectedStatus === 'work'
        })
    },
    makeTimeCorrect ($event) {
      let time = $event.target.value
      if (time.length === 5) {
        let timeArr = time.split(':')
        if (timeArr[0] > 23) {
          timeArr[0] = '23'
        }
        if (timeArr[1] > 59) {
          timeArr[1] = '59'
        }
        if ($event.target.id === 'timeFrom') {
          this.timeFrom = timeArr.join(':')
        } else {
          this.timeTo = timeArr.join(':')
        }
      }
    },

    addDatePickerWatchers() {
      // нужны для того, чтобы по клику на энтер в дейтпикере проставлялась новая дата, а не предыдущая

      this.$watch(
        () => {
          return this.$refs.datePickerFrom.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.dateFrom = tmpValueForDatePicker;
            this.$refs.datePickerFrom.popupVisible = false;
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePickerFrom.userInput = '';
            this.$refs.datePickerFrom.currentValue = null;
          }
        }
      );

      this.$watch(
        () => {
          return this.$refs.datePickerTo.userInput
        },
        (newVal, oldVal) => {
          let tmpValueForDatePicker = utils.spotNewValueForDatePicker(newVal, oldVal);
          if (tmpValueForDatePicker) {
            this.dateTo = tmpValueForDatePicker;
            this.$refs.datePickerTo.popupVisible = false;
          } else if (tmpValueForDatePicker === null) {
            this.$refs.datePickerTo.userInput = '';
            this.$refs.datePickerTo.currentValue = null;
          }
        }
      );
    }
  },
  mounted () {
    this.addDatePickerWatchers();
    this.isNew = this.timeFrom === null || this.timeTo === null || this.timeFrom === '' || this.timeTo === ''
  }
}
</script>
